import React from "react";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";

const Pagination = ({
  currentPage,
  rowsPerPage,
  totalRows,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [15, 20, 25], // default 
}) => {
  const totalVendor = Math.ceil(totalRows / rowsPerPage);

  return (
    <div className="flex items-center justify-start space-x-4 md:space-x-7 px-0 pt-1 fixed bottom-0 bg-G20 w-full z-30">
       <div className="flex items-center gap-2">
        <label htmlFor="rowsPerPage" className="text-[12px] xs:text-sm text-[#202224]">
          Rows per page:
        </label>
        <select
          id="rowsPerPage"
          value={rowsPerPage}
          onChange={(e) => onRowsPerPageChange(parseInt(e.target.value))}
          className="text-[12px] xs:text-sm rounded-md p-1 outline-none bg-G20"
        >
          {rowsPerPageOptions?.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
      <div className="flex items-center">
        <span className="text-[12px] xs:text-sm text-[#202224]">
          {`${(currentPage - 1) * rowsPerPage + 1}-${
            Math.min(currentPage * rowsPerPage, totalRows)
          } of ${totalRows}`}
        </span>
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`py-2 px-3 border border-G30 rounded-l-lg text-Grey100 font-bold ml-3 md:ml-7 ${
            currentPage === 1 ? "bg-green50 cursor-not-allowed" : "bg-white "
          }`}
        >
          <BsChevronLeft />
        </button>
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalVendor}
          className={`py-2 px-3 border border-l-0 border-G30 rounded-r-lg text-G500 font-bold ${
            currentPage === totalVendor ? "bg-green50 cursor-not-allowed" : "bg-white"
          }`}
        >
          <BsChevronRight />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
